import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { GridOptions } from 'ag-grid/main';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {
  CommonUtility, ComponentSummary, EmploymentPlanSummary, Components, WpPerson, EDIT_BTN, AgGridUtility,
  EmploymentPlan, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE,
  AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, EmploymentPlanCorVo, ComponentInfoVo
} from '../shared';
import { DateUtility, ServerConstantsService, TRIPLE_ROW_HEADER } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService, MIN_CHAR_SEARCH_LENGTH } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { ComponentRecommendation } from '../shared/model/component-recommendation.model';
import { EmploymentPlansSummary } from '../shared/model/employment-plans-summary.model';
import { EmploymentPlans } from '../shared/model/employment-plans.model';

@Component({
  selector: 'app-component-summary',
  templateUrl: './component-summary.component.html',
  styleUrls: ['./component-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class ComponentSummaryComponent implements OnInit {
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;

  gridOptions: GridOptions;
  employmentPlan: EmploymentPlan;
  employmentPlans: EmploymentPlans[];
  employmentPlansCopy: EmploymentPlan[] = [];
  enrollmentId: Number;
  componentSummary: ComponentSummary;
  employmentPlanSummary: EmploymentPlanSummary;
  components: Components[] = [];
  component: Component;
  programMap: any;
  relationshipArray: any[];
  relationshipMap: any;
  elasticSuggestions = new BehaviorSubject<any>(null);
  elasticSuggestionsUser = new BehaviorSubject<any>(null);
  suggestions: any = [];
  suggestionsUser: any = [];
  ServerConstants: any;
  userActionNotificationsMap: any;
  refData: any;
  sharedData: any;
  currentSearch: String;
  wpenrollmentId = '';
  wpPersonId = '';
  noData: Boolean = false;
  error: Boolean = false;
  isAddBtn: Boolean = false;
  caseNoteMap: any;
  columnDefs: any;
  context: any;
  taskTypesJson: any;
  taskStatusJson: any;
  countiesJson: any;
  countiesMap: any;
  counties: any;
  assignedToJson: any;
  componentMap: any;
  assignedToDD: any;
  empPlanStatusMap: any;
  shortTermGoalMap: any;
  longTermGoalMap: any;
  shortTermGoalArray: any[];
  longTermGoalArray: any[];
  empPlanStatusArray: any[];
  wpPerson: WpPerson;
  index: any;
  TRIPLE_ROW_HEADER = TRIPLE_ROW_HEADER;
  tabIndex: any = '-1';
  tabToNextCell: any;

  auditColumnDefs: any; // audit

  @ViewChild('headerText') headerText: ElementRef;
  gridApi: any;
  firstTime: Boolean = true;
  loaderFocus : Boolean = false;

  selectedEmploymentPlan;
  employmentArray = [];
  overAllProgressComponents = [];
  disableRecommendations: Boolean = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
  ) {
    this.gridOptions = <GridOptions>{};
    this.ServerConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('COMPS') === undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.overAllProgressComponents = [];
    /* Load Reference Tables*/
    console.log(this.dataService.getSharedDataObject().get('COMPS'));
    this.index = this.dataService.getSharedDataObject().get('COMPS').innerNavPages.find(x => x.pageId === 'COMSU');
    if (this.index.readOnly) {
      this.tabIndex = '0';
    }
    this.data.currentMessage.subscribe(
      (message) => {
        this.refData = message;
        this.parseRefTableData(message);
      });
    this.shortTermGoalArray = this.data.getValueFromSharedDataMap('EMPLOYMENT_SHORT_TERM_GOAL');
    this.shortTermGoalMap = this.commonUtil.createMapFromList(this.shortTermGoalArray);
    this.longTermGoalArray = this.data.getValueFromSharedDataMap('EMPLOYMENT_LONG_TERM_GOAL');
    this.longTermGoalMap = this.commonUtil.createMapFromList(this.longTermGoalArray);

    const countiesArray = this.data.getValueFromSharedDataMap('COUNTIES');
    this.countiesMap = this.commonUtil.createMapFromList(countiesArray);


    this.sharedData = this.dataService.getSharedDataObject();

    this.employmentPlanSummary = new EmploymentPlanSummary();
    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      this.employmentPlanSummary.etEnrollmentId = Number(this.sharedData.get('etEnrollment').id);
    }
    this.getColumnDefinitions();
    this.componentSummary = new ComponentSummary();

    if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
      const request = new RequestLoadAll(parseInt(this.sharedData.get('wpPersonId')));
      this.loademploymentPlan(request);
    }  

    // Audit Method
    this.auditColumnDefinations();

    this.loadRecommendations();

  }
  parseRefTableData(myData) {
    if (myData !== undefined && myData.englishDropDown) {
      this.empPlanStatusArray = myData.englishDropDown['EMPLOYMENT_PLAN_STATUS'];
      this.empPlanStatusMap = this.commonUtil.createNativeMapFromList(this.empPlanStatusArray);
      const component = myData.englishDropDown['COMPONENTS'];
      this.componentMap = this.commonUtil.createMapFromList(component);
      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown['USER-ACTION-NOTIFICATIONS']);
      this.taskStatusJson = this.commonUtil.createNativeMapFromList(component);
    }
  }

  reloadData(event) {
    event.srcElement.blur();
    event.preventDefault();
    this.loaderFocus = true;
    this.reloadComponents();
  }

  reloadComponents() {
    if (this.selectedEmploymentPlan !== undefined && this.selectedEmploymentPlan.length > 0) {
      const arrayObj = this.selectedEmploymentPlan.split(' - ');
      if (arrayObj.length === 2 || arrayObj.length === 3) {
        const empId = Number(arrayObj[0]);
        this.employmentPlans.forEach(element => {
          this.overAllProgressComponents.push(element.id);
          if (element.id === empId) {
            this.employmentPlan = element;
            if (this.employmentPlan.empPlanStatusCd === 'OP') {


              this.isAddBtn = false;

            } else {

              this.isAddBtn = true;
              this.tabIndex = '0';

            }
            this.componentSummary.employment_plan_id = this.employmentPlan.id;
            this.dataService.addValueToSharedDataMap('employmentPlanForComponent', this.employmentPlan);
            this.dataService.addValueToSharedDataMap('selectedEPForComponent', this.selectedEmploymentPlan);

            console.log('selectedEPForComponent: ' + this.selectedEmploymentPlan);
            this.load();
          }


        });
        this.dataService.addValueToSharedDataMap('overAllProgressComponents', this.overAllProgressComponents);

      }
    }

  }
  loademploymentPlan(request) {
    this.http.post<EmploymentPlansSummary>(this.ServerConstants.SERVER_API_URL + '/employmentplan/list',
      request).subscribe(
        (data: EmploymentPlansSummary) => {
          if (data.hasOwnProperty('errorCode')) {
            this.notificationService.error('EmploymentPlan Summary', this.userActionNotificationsMap.ERROR);
          } else {
            if (data != null) {
              if (data.employmentPlans.length > 0) {

                this.employmentPlans = data.employmentPlans;
                this.employmentPlans.forEach(element => {
                  if(element.enrollmentEndDt != null && element.enrollmentEndDt != undefined && element.enrollmentEndDt != 'Current')
                    this.employmentArray.push(element.id + ' - ' + this.empPlanStatusMap[element.empPlanStatusCd] + ' - Prior Enrollment ');
                  else 
                    this.employmentArray.push(element.id + ' - ' + this.empPlanStatusMap[element.empPlanStatusCd]);
                });
                const existingEmp = this.sharedData.get('selectedEPForComponent');
                if (existingEmp !== undefined && existingEmp !== null && existingEmp !== '') {
                  this.selectedEmploymentPlan = existingEmp;
                  this.reloadComponents();

                } else {
                  this.selectedEmploymentPlan = this.employmentArray[0];
                  this.reloadComponents();
                }

              } else {
                this.isAddBtn = true;
                this.tabIndex = '0';

              }
            }
          }
        }, response => {
          this.error = true;
          this.notificationService.error('Component Summary', this.userActionNotificationsMap.ERROR);
        }, () => {
          this.error = false;
        });
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Employment Plan',
        field: 'employmentPlan.id',
        cellRenderer: this.getEmpolymentPlan,

      },
      {
        headerName: 'Component Name',
        field: 'componentCd',
        refData: this.taskStatusJson
      },
      {
        headerName: 'Service Provider',
        field: 'serviceProviderName'
      },
      { headerName: 'Monthly Authorized Hours', width: 150, field: 'authorizedHours' },
      { headerName: 'Monthly Calculated Hours', width: 140, field: 'countableHours' },
      {
        headerName: 'Start Date', width: 140, field: 'startDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        }
      },
      {
        headerName: 'End Date', width: 130, field: 'estimatedCompletionDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        }
      },
      {
        headerName: 'Action', width: 110, field: '', cellRenderer: this.getEditButton,
        suppressFilter: true,
        suppressSorting: true
      },

    ];

    this.context = {
      component: this,
    };
    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  auditColumnDefinations() {
    this.auditColumnDefs = [
      {
        headerName: 'Component Name',
        field: 'componentCd',
        refData: this.taskStatusJson,
        tooltip: (params) => {
          const taskStatusMap = params.context.taskStatusJson;
          const taskStatuCode = params.data.componentCd;
          const taskStatus = taskStatusMap[taskStatuCode];
          return taskStatus;
        }
      },
      {
        headerName: 'Employment Plan',
        field: 'employmentPlan.id',
        tooltipField: 'employmentPlan.id'
      },
      {
        headerName: 'Component Status',
        field: 'employmentPlan.empPlanStatusCd',
        refData: this.empPlanStatusMap,
        width: 160,
        tooltip: (params) => {
          const empPlanStatusMap = params.context.empPlanStatusMap;
          const empPlanStatusCode = params.data.employmentPlan.empPlanStatusCd;
          const empPlanStatus = empPlanStatusMap[empPlanStatusCode];
          return empPlanStatus;
        }
      },
      {
        headerName: 'Modified By',
        field: 'createdBy',
        width: 160,
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Start Date', width: 140, field: 'startDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        },
        tooltip: this.formatDates
      },
      {
        headerName: 'End Date', width: 130, field: 'estimatedCompletionDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.formatDates,
        filterParams: {
          comparator: this.filterDates,
        },
        tooltip: this.formatDates
      },
      {
        headerName: 'Monthly Authorized Hours',
        width: 150,
        field: 'authorizedHours',
        tooltipField: 'authorizedHours'
      },
      {
        headerName: 'Monthly Calculated Hours',
        width: 140,
        field: 'countableHours',
        tooltipField: 'countableHours'
      }
    ];
  }

  getEmpolymentPlan(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    element.innerHTML = params.data.employmentPlan.id;
    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('employmentPlan', params.data.employmentPlan);
      that.router.navigate(['/task/employmentPlanSummary/employmentPlan']);
    });
    element.addEventListener('keydown', () => {
      that.dataService.addValueToSharedDataMap('employmentPlan', params.data.employmentPlan);
      that.router.navigate(['/task/employmentPlanSummary/employmentPlan']);
    });
    element.setAttribute('tabindex', '0');
    return element;
  }

  getEditButton(params) {
    const that = params.context.component;

    const divRow = document.createElement('div');
    divRow.setAttribute('class', 'row');

    // Edit Button
    const element = document.createElement('a');
    const image = EDIT_BTN;
    element.innerHTML = image;
    element.setAttribute('tabindex', '0');
    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('componentObject', params.data);
      that.router.navigate(['/task/componentSummary/componentDetails']);
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('componentObject', params.data);
        that.router.navigate(['/task/componentSummary/componentDetails']);
      } else if (event.keyCode === 9) {
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }

    });
    element.setAttribute('tabindex', '0');

    const divCol1 = document.createElement('div');
    divCol1.setAttribute('class', 'col-2 right-margin-1');

    divCol1.appendChild(element);

    // Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    element.setAttribute('tabindex', '0');
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.Component');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Component Audit');
      that.router.navigate(['/task/componentSummary/auditHistory']);
    });
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.Component');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Component Audit');
        that.router.navigate(['/task/componentSummary/auditHistory']);
      } /*else if ((!event.shiftKey && event.keyCode === 9) && (params.rowIndex === (that.components.length - 1))) {
        event.preventDefault();
        setTimeout(() => that.headerText.nativeElement.focus(), 0);
        that.headerText.nativeElement.click();
      }
*/
    });
    auditElement.setAttribute('tabindex', '0');

    const divCol2 = document.createElement('div');
    divCol2.setAttribute('class', 'col-1');
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);

    return divRow;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }
  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.columnDefs;
    } else {
      this.gridOptions.api.sizeColumnsToFit();
    }
  }
  formatDates(params) {
    if (!params.value) {
      return null;
    }


    const dateParts = params.value.split('/');

    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '/' + day + '/' + year;
  }

  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }

    const dateParts = cellValue.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  load() {
    this.http.post<ComponentSummary>(this.ServerConstants.SERVER_API_URL + '/component/load', this.componentSummary).subscribe(
      (data: ComponentSummary) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('ComponentDetails Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data != null) {
            if (data.component.length > 0) {
              this.components = data.component;
              this.components.forEach(row => {
                row.countableHours = row.countableHours.toFixed(1);
                row.authorizedHours = row.authorizedHours.toFixed(1);

              });

            } else {
              this.components = [];
              this.noData = true;
            }
          }
        }

      }, response => {
        this.error = true;
        this.notificationService.error('CaseNotes Summary', this.userActionNotificationsMap.ERROR);
      }, () => {
        this.error = false;
      });

  }
  loadComponentDetails() {
    this.dataService.removeValueFromSharedDataMap('componentObject');
    this.router.navigate(['/task/componentSummary/componentDetails']);

  }

  reviewRecommendations() {
    this.dataService.removeValueFromSharedDataMap('componentObject');
    this.router.navigate(['/task/componentSummary/reviewRecommendations']);
  }

  printEmploymentPlan() {

    let wpPerson;
    if (this.sharedData.get('wpPerson') !== null && this.sharedData.get('wpPerson') !== undefined) {
      wpPerson = this.sharedData.get('wpPerson');
    }

    let ssn;
    if (this.sharedData.get('SSN_SEARCH') !== null && this.sharedData.get('SSN_SEARCH') !== undefined) {
      ssn = this.sharedData.get('SSN_SEARCH');
    }
    const providerId = this.sharedData.get('providerId');
    const providerList = this.sharedData.get('providers');
    const providerName = providerList.get(providerId);

    let personId = 0;
    if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
      personId = Number(this.sharedData.get('wpPersonId'));
    }

    let assignedTo = 0;
    if (providerId > 0) {
      assignedTo = providerId;
    } else {
      const personProvider = this.sharedData.get('personProvider');
      if (personProvider !== undefined && personProvider != null && personProvider.id !== undefined) {

        assignedTo = personProvider.id.serviceCounty;

      }
    }

    if (this.employmentPlan !== undefined && this.employmentPlan.id !== undefined && this.employmentPlan.id > 0) {

      const employmentPlanCorVo = new EmploymentPlanCorVo();
      employmentPlanCorVo.id = this.employmentPlan.id;
      employmentPlanCorVo.clientName = wpPerson.firstName + ' ' + wpPerson.lastName;
      employmentPlanCorVo.clientSSN = ssn;
      employmentPlanCorVo.provider = providerName;
      employmentPlanCorVo.providerCounty = this.countiesMap.get(String(assignedTo));
      employmentPlanCorVo.empPlanStartDt = this.employmentPlan.empPlanStartDt,
        employmentPlanCorVo.estimatedCompletionDt = this.employmentPlan.estimatedCompletionDt;
      employmentPlanCorVo.clientAgreementDt = this.employmentPlan.clientAgreementDt;
      employmentPlanCorVo.shortTermGoalCd = this.shortTermGoalMap.get(this.employmentPlan.shortTermGoalCd);
      employmentPlanCorVo.longTermGoalCd = this.longTermGoalMap.get(this.employmentPlan.longTermGoalCd);
      employmentPlanCorVo.notes = this.employmentPlan.notes;
      employmentPlanCorVo.personId = personId;
      const componentList: ComponentInfoVo[] = [];
      this.components.forEach(component => {
        const componentInfoVo: ComponentInfoVo = new ComponentInfoVo();
        componentInfoVo.authorizedHours = String(component.authorizedHours);
        componentInfoVo.componentName = this.componentMap.get(component.componentCd);
        componentInfoVo.estimatedCompletionDt = component.estimatedCompletionDt;
        componentInfoVo.startDt = component.startDt;
        componentList.push(componentInfoVo);
      });

      if (componentList.length > 0) {


        employmentPlanCorVo.componentInfoVos = componentList;
        this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/component/print-employment-plan', employmentPlanCorVo)
          .subscribe(
            (res: any) => {
              if (res.hasOwnProperty('errorCode')) {
                this.notificationService.error('Print Employment Plan', this.userActionNotificationsMap.ERROR);
              } else {
                if (res.status === 'success') {
                  this.notificationService.success('Print Employment Plan', 'Print Employment Plan trigger generated');
                  this.router.navigate(['task/correspondence']);
                }
              }
            },
            (response) => {
              this.notificationService.error('Print Employment Plan', this.userActionNotificationsMap.ERROR);
            },
            () => {
            });

      } else {
        this.notificationService.warn('Print Employment Plan', 'Atleast one component required to print employment plan');
      }

    } else {
      this.notificationService.warn('Print Employment Plan', 'Open employment plan not found');
    }

  }

  /*focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }*/

  focusSummary(event) {
    const enterKeyCode = 13;
    const spaceKeyCode = 32;

    if (event.keyCode === enterKeyCode || event.keyCode === spaceKeyCode) {
      this.loadComponentDetails();
    }

    if (this.components.length === 0) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    } else {
      this.firstTime = false;
      this.addEventListenerToButton(event);
    }
  }

  addEventListenerToButton(event) {
    const tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }

    if (this.components.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }


  toggleMultiselctDDKeyboard(event: KeyboardEvent) {
    const KEY_UP = 38;
    const KEY_DOWN = 40;
    const multiselectDDElement = (<HTMLElement>event.target);
    if (event.altKey) {
      if (event.keyCode === KEY_DOWN || event.keyCode === KEY_UP) {
        const multisectDDChildNodes = multiselectDDElement.querySelectorAll('.dropdown-list');
        let hiddenAttrsFound = false;

        if (multisectDDChildNodes) {
          for (let i = 0; i < multisectDDChildNodes.length; i++) {
            if ((<HTMLElement>multisectDDChildNodes[i]).hasAttribute('hidden')) {
              hiddenAttrsFound = true;
              break;
            }
          }

          for (let i = 0; i < multisectDDChildNodes.length; i++) {
            if (hiddenAttrsFound) {
              multisectDDChildNodes[i].removeAttribute('hidden');
            } else {
              multisectDDChildNodes[i].setAttribute('hidden', '');
            }
          }
        }
      }
    }
  }


  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  onPaginationChanged() {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick(event) {
    this.firstTime = false;
  }

  loadRecommendations() {   

    let personId;
    if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
      personId = this.sharedData.get('wpPersonId');
    }
    console.log('personId =='+ personId);
    
    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      console.log('etEnrollment ==' + this.sharedData.get('etEnrollment').id);      
    }

    if (personId !== null && this.sharedData.get('etEnrollment') !== null) {
      console.log(' personId - ' + personId + ' and etEnrollmentID - ' + this.sharedData.get('etEnrollment').id)
      const request = new RequestLoad(personId, this.sharedData.get('etEnrollment').id);
      
     
      this.http.post<ComponentRecommendation[]>(this.ServerConstants.SERVER_API_URL + '/component/recommendations', request).subscribe(
        (data) => {       
            if (data.length > 0) {
              this.disableRecommendations = false;            
            } else {
              this.disableRecommendations = true;           
            }
          
        }, response => {
         
        }, () => {
  
        });
    }

    console.log(' === this.disableRecommendations ' + this.disableRecommendations);

    }

    

}

class RequestLoad {
  constructor(
    public wpPersonId: String,
    public etEnrollmentId: String
  ) {
  }
}

class RequestLoadAll {
  constructor(
    public personId: Number
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/component-summary/component-summary.component.ts